import React from 'react';
import ReactTypingEffect from 'react-typing-effect';

import img from 'assets/images/Backoffice/my-back-office.svg';
import bg from 'assets/images/Backoffice/bg-sm-lines.svg';
import style from './HomeFirstSection.module.scss';

const typingTextSettings = (cursorClassName: string) => ({
  text: ['Onboarding', 'Invoicing', 'Payroll', 'Compliance administration'],
  speed: 50,
  eraseDelay: 2000,
  typingDelay: 1000,
  cursorClassName,
});

export default function HomeFirstSection() {
  return (
    <div className={style.section}>
      <div className={style.bg}>
        <div className="container">
          <div className={style.contentWrapper}>
            <div className={style.subTitle}>full suite of</div>

            <div className={style.title}>
              Back-office <br />
              solutions
            </div>

            <div className={style.animatedBox}>
              <div className={style.animatedContent}>
                myBasePay Back-Office is a complete suite of solutions for full
                cycle
              </div>
              <ReactTypingEffect {...typingTextSettings(style.typingCursor)} />
            </div>
          </div>
        </div>

        <div className={style.bottomBg}>
          <div className="container">
            <div className={style.bottomText}>
              We've elevated the EOR landscape with transformative funding that
              enables zero-risk scaling.
            </div>
          </div>

          <div className="hidden-sm-up">
            <img src={bg} alt="" />
          </div>
        </div>

        <img src={img} alt="" />
      </div>
    </div>
  );
}
